import { accessTokenCookieKey, createAuthUtils, refreshTokenCookieKey } from "@sweatpals/react-ui-kit";
import { API_URL } from "./env";

export const getHomeBannerText = (locationName: string) => `Discover and join your favorite fitness communities & events in ${locationName}`;
export const PUBLIC_FILE_PATH = API_URL + '/files/';

export const storageKeys = {
	access: 'access_token',
	refresh: 'refresh_token',
	userId: 'userId',
	locationId: 'locationId',
};

export const authUtils = createAuthUtils(process.env['NEXT_PUBLIC_COOKIES_DOMAIN'] ?? '', process.env['NEXT_PUBLIC_COOKIES_PREFIX']);

export const searchDelayMs = 500;
